import React, { useLayoutEffect, useEffect } from "react";
import "isomorphic-fetch";
import { Link } from "react-router-dom";
import "animate.css/animate.min.css";

import ContactForm from "./Component/ContactForm";

const ContactUs = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (window.innerWidth >= 767) {
      import("wowjs").then((WOW) => {
        const wow = new WOW.WOW();
        if (typeof window !== "undefined") {
          wow.init();
        }
      });
      return () => {};
    }
  }, []);

  return (
    <>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row gap-10 md:gap-5 lg:gap-[44px] py-[40px] md:py-[60px] xl:pt-[93px] xl:pb-[160px] md:px-5 lg:px-10">
          <div className="w-full md:w-1/2 xl:w-[46%] text-center md:text-left">
            <div className="section-sub-title mb-[10px] md:mb-5">
              We Are Here To Help You
            </div>
            <div className="section-title">
              Let's Transform
              <br className="hidden xl:block" /> Your Vision Into
              <br className="hidden xl:block" /> Value.
            </div>
            <div className="contact-us-info mt-10">
              <div className="title text-left">Contact us</div>
              <ul className="contact-info-list">
                <li>
                  <svg
                    width="22"
                    height="23"
                    viewBox="0 0 22 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_504_3190)">
                      <path
                        d="M18.333 4.16675H3.66634C2.65801 4.16675 1.84217 4.99175 1.84217 6.00008L1.83301 17.0001C1.83301 18.0084 2.65801 18.8334 3.66634 18.8334H18.333C19.3413 18.8334 20.1663 18.0084 20.1663 17.0001V6.00008C20.1663 4.99175 19.3413 4.16675 18.333 4.16675ZM17.9663 8.06258L11.4855 12.1142C11.1922 12.2976 10.8072 12.2976 10.5138 12.1142L4.03301 8.06258C3.80384 7.91591 3.66634 7.66841 3.66634 7.40258C3.66634 6.78841 4.33551 6.42175 4.85801 6.74258L10.9997 10.5834L17.1413 6.74258C17.6638 6.42175 18.333 6.78841 18.333 7.40258C18.333 7.66841 18.1955 7.91591 17.9663 8.06258Z"
                        fill="#80868B"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_504_3190">
                        <rect
                          width="22"
                          height="22"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <Link to={"mailto:hello@reactbytes.com"}>
                    hello@reactbytes.com
                  </Link>
                </li>
                <li>
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_504_3166)">
                      <path
                        d="M19.2921 12.1415C19.2858 12.1766 19.2813 12.2121 19.2747 12.2472L19.2405 12.0458C19.2592 12.0772 19.2747 12.1098 19.2921 12.1415C19.3954 11.5796 19.4495 11.0044 19.4495 10.4295C19.4495 9.15468 19.1999 7.91785 18.7068 6.75354C18.2311 5.62883 17.5504 4.61877 16.6826 3.75156C15.816 2.88435 14.8053 2.2037 13.6812 1.72797C12.5172 1.23545 11.2804 0.985866 10.0055 0.985866C9.4047 0.985866 8.80291 1.04224 8.21728 1.15468C8.21601 1.155 8.21443 1.155 8.21284 1.15532C8.24578 1.17274 8.27904 1.18826 8.31135 1.20631L8.11276 1.17527C8.14601 1.16894 8.17959 1.16197 8.21284 1.15532C7.4093 0.728047 6.50566 0.5 5.59094 0.5C4.09755 0.5 2.69348 1.08152 1.6375 2.13782C0.581835 3.1938 0 4.59787 0 6.09126C0 7.04177 0.244517 7.97613 0.70346 8.80185C0.709478 8.76764 0.713596 8.73311 0.720247 8.69891L0.754454 8.89686C0.736717 8.86582 0.721197 8.83352 0.70346 8.80185C0.610341 9.3368 0.561248 9.88348 0.561248 10.4295C0.561248 11.7047 0.810832 12.9412 1.30398 14.1058C1.77908 15.2309 2.46005 16.2403 3.32695 17.1075C4.19479 17.9747 5.20421 18.6563 6.32956 19.1308C7.49355 19.6242 8.7307 19.8741 10.0055 19.8741C10.5605 19.8741 11.1166 19.8235 11.6595 19.7272C11.6278 19.7094 11.5955 19.6933 11.5632 19.6746L11.765 19.7101C11.7301 19.7167 11.695 19.7208 11.6595 19.7272C12.496 20.2004 13.443 20.4519 14.41 20.4519C15.9031 20.4519 17.3065 19.8713 18.3625 18.8147C19.4188 17.7593 20 16.3549 20 14.8615C20 13.9079 19.7542 12.9703 19.2921 12.1415ZM10.0432 16.2134C6.6881 16.2134 5.18711 14.5638 5.18711 13.3276C5.18711 12.6935 5.65524 12.2491 6.30042 12.2491C7.73616 12.2491 7.36432 14.3108 10.0432 14.3108C11.4147 14.3108 12.172 13.5661 12.172 12.8041C12.172 12.3458 11.9458 11.8377 11.0428 11.6151L8.05859 10.8701C5.65524 10.2674 5.2191 8.96813 5.2191 7.74681C5.2191 5.21106 7.60662 4.25897 9.84876 4.25897C11.9142 4.25897 14.3489 5.40047 14.3489 6.92173C14.3489 7.57356 13.7845 7.95269 13.1396 7.95269C11.9142 7.95269 12.1397 6.25659 9.67139 6.25659C8.44659 6.25659 7.76815 6.81119 7.76815 7.60492C7.76815 8.39706 8.73545 8.65013 9.57542 8.84144L11.7843 9.33174C14.2038 9.87081 14.8173 11.2834 14.8173 12.614C14.8173 14.6747 13.2356 16.2134 10.0432 16.2134ZM11.5632 19.6746C11.5955 19.6933 11.6278 19.7094 11.6595 19.7272C11.695 19.7208 11.7301 19.7167 11.765 19.7101L11.5632 19.6746ZM19.2747 12.2472C19.2813 12.2121 19.2858 12.1766 19.2921 12.1415C19.2747 12.1098 19.2592 12.0772 19.2405 12.0458L19.2747 12.2472ZM0.720247 8.69891C0.713596 8.73311 0.709478 8.76764 0.70346 8.80185C0.721197 8.83352 0.736717 8.86582 0.754454 8.89686L0.720247 8.69891ZM8.31135 1.20631C8.27904 1.18826 8.24578 1.17274 8.21284 1.15532C8.17959 1.16197 8.14601 1.16894 8.11276 1.17527L8.31135 1.20631Z"
                        fill="#80868B"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_504_3166">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <Link to={"skype:tristate.tech?chat"}>tristate.tech</Link>
                </li>
                <li className="md:w-full">
                  <svg
                    width="21"
                    height="25"
                    viewBox="0 0 21 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.31705 2H14.6271C15.9061 2.00152 16.9426 3.05918 16.9441 4.3643V19.6355C16.9426 20.9408 15.9062 21.9985 14.6272 22H6.31705C5.03802 21.9985 4.00153 20.9408 4 19.6357V4.36447C4.00153 3.05922 5.03812 2.0015 6.31705 2ZM7.98079 2.66666H12.972V3.55553C12.972 4.04646 12.582 4.44443 12.101 4.44443H8.80832C8.32724 4.44443 7.93727 4.04646 7.93727 3.55557V2.66664L7.98079 2.66666ZM11.2996 19.4578H9.64455V18.1244H11.2996V19.4578Z"
                      fill="#80868B"
                    />
                    <circle cx="10.5" cy="17.5" r="1.5" fill="white" />
                  </svg>
                  <Link to={"tel:+44 7884 120778"}>+44 7884 120778</Link>
                </li>
              </ul>
              <div className="title mt-[40px] md:mt-[60px] text-left">
                Follow Us
              </div>
              <ul className="contact-follow">
                <li>
                  <Link
                    to="https://www.facebook.com/reactbytes"
                    target="__blank"
                  >
                    <svg
                      width="12"
                      height="19"
                      viewBox="0 0 12 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.20194 10.7328V18.3176H3.71778V10.7328H0.823242V7.6574H3.71778V6.53845C3.71778 2.38425 5.45316 0.199951 9.12493 0.199951C10.2506 0.199951 10.532 0.38086 11.1484 0.528267V3.57021C10.4583 3.4496 10.264 3.3826 9.54705 3.3826C8.69611 3.3826 8.24049 3.62381 7.82507 4.09953C7.40965 4.57526 7.20194 5.39939 7.20194 6.57865V7.6641H11.1484L10.0898 10.7395H7.20194V10.7328Z"
                        fill="#80868B"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.linkedin.com/company/reactbytes/"
                    target="__blank"
                  >
                    <svg
                      width="20"
                      height="19"
                      viewBox="0 0 20 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.02895 6.15808H1.24316V18.2307H5.02895V6.15808Z"
                        fill="#80868B"
                      />
                      <path
                        d="M15.2708 5.89639C15.1312 5.87895 14.9829 5.87022 14.8346 5.8615C12.715 5.77427 11.5199 7.03038 11.1012 7.57121C10.9878 7.7195 10.9355 7.80673 10.9355 7.80673V6.19297H7.31543V18.2656H10.9355H11.1012C11.1012 17.0357 11.1012 15.8144 11.1012 14.5845C11.1012 13.9215 11.1012 13.2586 11.1012 12.5957C11.1012 11.7757 11.0402 10.9034 11.4501 10.1532C11.7991 9.52516 12.4271 9.21113 13.1337 9.21113C15.2272 9.21113 15.2708 11.104 15.2708 11.2785C15.2708 11.2872 15.2708 11.2959 15.2708 11.2959V18.3179H19.0566V10.4411C19.0566 7.74567 17.6871 6.15808 15.2708 5.89639Z"
                        fill="#80868B"
                      />
                      <path
                        d="M3.13667 4.59658C4.3507 4.59658 5.33487 3.61242 5.33487 2.39839C5.33487 1.18436 4.3507 0.200195 3.13667 0.200195C1.92264 0.200195 0.938477 1.18436 0.938477 2.39839C0.938477 3.61242 1.92264 4.59658 3.13667 4.59658Z"
                        fill="#80868B"
                      />
                    </svg>
                  </Link>
                </li>
                <li>
                  <Link to="https://x.com/ReactBytes" target="__blank">
                    <svg
                      width="20"
                      height="18"
                      viewBox="0 0 20 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.54649 0.717773H0.683594L7.63487 9.86661L1.12828 17.5413H4.13452L9.05572 11.7367L13.4255 17.4879H19.2884L12.1351 8.07319L12.1478 8.08943L18.3069 0.824608H15.3007L10.7268 6.2196L6.54649 0.717773ZM3.91982 2.32003H5.74503L16.0522 15.8856H14.227L3.91982 2.32003Z"
                        fill="#80868B"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full md:w-1/2 xl:w-[54%]">
            <div className="contact-form-area">
              <div className="title">Start Your Project With Best Brains!</div>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactUs;
